// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_white":"#FFFFFF","formControl":"NewBulletinModal_formControl__2IaBi","select":"NewBulletinModal_select__3uFsW"};